const toRadians = (value) => {
  return (value * Math.PI) / 180
}

const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const worldRadius = 6371e3
  const firstLatitude = toRadians(lat1)
  const secondLatitude = toRadians(lat2)
  const deltaLatitude = toRadians(lat2 - lat1)
  const deltaLongitude = toRadians(lon2 - lon1)
  const a =
    Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
    Math.cos(firstLatitude) * Math.cos(secondLatitude) * Math.sin(deltaLongitude / 2) * Math.sin(deltaLongitude / 2)

  return worldRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

const getCurrentPosition = (options) => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}

const buildRejectedGeolocationResult = (reason) => {
  return {
    ok: false,
    reason,
    distance: null,
    lat: null,
    lon: null,
    accuracyM: null,
  }
}

const requestGeolocationVerification = async (barrierLocation, maxDistanceMeters = 50) => {
  if (!navigator.geolocation) {
    return buildRejectedGeolocationResult('not_supported')
  }

  try {
    const position = await getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 6000,
      maximumAge: 0,
    })

    const userLatitude = position.coords.latitude
    const userLongitude = position.coords.longitude
    const accuracyM = position.coords.accuracy ?? null

    if (!barrierLocation?.latitude || !barrierLocation?.longitude) {
      return buildRejectedGeolocationResult('BARRIER_LOCATION_MISSING')
    }

    const distance = calculateDistance(userLatitude, userLongitude, barrierLocation.latitude, barrierLocation.longitude)
    const roundedDistance = Math.round(distance)

    if (distance > maxDistanceMeters) {
      return {
        ok: false,
        reason: 'far',
        distance: roundedDistance,
        lat: userLatitude,
        lon: userLongitude,
        accuracyM,
      }
    }

    return {
      ok: true,
      reason: null,
      distance: roundedDistance,
      lat: userLatitude,
      lon: userLongitude,
      accuracyM,
    }
  } catch (error) {
    if (error?.code === error?.PERMISSION_DENIED || error?.code === 1) {
      return buildRejectedGeolocationResult('permission_denied')
    }
    if (error?.code === error?.POSITION_UNAVAILABLE || error?.code === 2) {
      return buildRejectedGeolocationResult('unavailable')
    }
    if (error?.code === error?.TIMEOUT || error?.code === 3) {
      return buildRejectedGeolocationResult('timeout')
    }

    return buildRejectedGeolocationResult('unknown')
  }
}

export { calculateDistance, requestGeolocationVerification }
